import FormHelperText from "@mui/material/FormHelperText/FormHelperText";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Select from "@mui/material/Select/Select";
import { FC } from "react";
import { ProposalActions } from "../../libs/daoService";
import {
  CustomMessageFields,
  CustomMessageParams,
  validateCustomMessageParams,
} from "./NoneActionFields";

export interface UpdateQuorumActionProps extends CustomMessageParams {
  kind: ProposalActions.changeQuorum;
  quorum: string;
}

export const validateUpdateQuorumActionParams = async (
  action: Partial<UpdateQuorumActionProps>
): Promise<Partial<UpdateQuorumActionProps>> => {
  const value: Partial<UpdateQuorumActionProps> = { kind: action.kind };

  Object.assign(value, validateCustomMessageParams(action));

  return value;
};

export const UpdateQuorumAction: FC<{
  params: Partial<UpdateQuorumActionProps>;
  setParams: (value: Partial<UpdateQuorumActionProps>) => void;
  disabled: boolean;
  submitted: boolean;
  validation: Partial<UpdateQuorumActionProps> | undefined;
}> = ({ params, setParams, disabled, submitted, validation }) => {
  return (
    <>
      <div>
        <FormHelperText sx={{ mx: "12px" }}>Quorum Params</FormHelperText>
        <Select
          fullWidth
          disabled={disabled}
          value={params.quorum}
          onChange={(e) => setParams({ quorum: e.target.value })}
        >
          <MenuItem value="2/3">66%</MenuItem>
          <MenuItem value="1/2">50%</MenuItem>
          <MenuItem value="1/4">25%</MenuItem>
          <MenuItem value="1/10">10%</MenuItem>
        </Select>
      </div>

      <CustomMessageFields
        params={params}
        setParams={setParams}
        disabled={disabled}
        submitted={submitted}
        validation={validation}
      />
    </>
  );
};
